export default __webpack_public_path__ + "static/media/frequency.49e80dad.svg";